"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderModule = void 0;
const tx_1 = require("../codec/Switcheo/carbon/leverage/tx");
const tx_2 = require("../codec/Switcheo/carbon/order/tx");
const util_1 = require("../util");
const number_1 = require("../util/number");
const order_1 = require("../util/order");
const base_1 = __importDefault(require("./base"));
class OrderModule extends base_1.default {
    create(param, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const { setLeverage } = param, createOrderParam = __rest(param, ["setLeverage"]);
            const params = [createOrderParam];
            if (setLeverage) {
                params.unshift({
                    leverage: setLeverage,
                    marketId: param.marketId,
                });
            }
            return this.createOrders(params, opts);
        });
    }
    createOrders(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const msgs = params.map((param) => {
                var _a, _b;
                if ("leverage" in param) {
                    return {
                        typeUrl: util_1.CarbonTx.Types.MsgSetLeverage,
                        value: tx_1.MsgSetLeverage.fromPartial({
                            creator: wallet.bech32Address,
                            marketId: param.marketId,
                            leverage: param.leverage.shiftedBy(18).toString(10),
                        }),
                    };
                }
                return {
                    typeUrl: util_1.CarbonTx.Types.MsgCreateOrder,
                    value: tx_2.MsgCreateOrder.fromPartial({
                        creator: wallet.bech32Address,
                        isPostOnly: param.isPostOnly,
                        isReduceOnly: param.isReduceOnly,
                        marketId: param.marketId,
                        orderType: param.orderType,
                        price: (_a = param.price) === null || _a === void 0 ? void 0 : _a.shiftedBy(18).toString(10),
                        quantity: param.quantity.toString(10),
                        side: param.side,
                        stopPrice: (_b = param.stopPrice) === null || _b === void 0 ? void 0 : _b.shiftedBy(18).toString(10),
                        timeInForce: param.timeInForce || (0, order_1.getDefaultTimeInForce)((0, order_1.isMarket)(param.orderType)),
                        triggerType: param.triggerType,
                        referralAddress: param.referralAddress,
                        referralCommission: param.referralCommission,
                        referralKickback: param.referralKickback,
                    }),
                };
            });
            return yield wallet.sendTxs(msgs, opts);
        });
    }
    cancel(orderId, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = {
                creator: wallet.bech32Address,
                id: orderId,
            };
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgCancelOrder,
                value,
            }, opts);
        });
    }
    cancelOrders(orderIds, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const msgs = orderIds.map((id) => {
                const value = {
                    creator: wallet.bech32Address,
                    id,
                };
                return {
                    typeUrl: util_1.CarbonTx.Types.MsgCancelOrder,
                    value,
                };
            });
            return yield wallet.sendTxs(msgs, opts);
        });
    }
    edit(params, opts) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = tx_2.MsgEditOrder.fromPartial({
                creator: wallet.bech32Address,
                id: params.id,
                price: params.price.shiftedBy(18).toString(10),
                quantity: params.quantity.toString(10),
                stopPrice: ((_b = (_a = params.stopPrice) === null || _a === void 0 ? void 0 : _a.shiftedBy(18)) !== null && _b !== void 0 ? _b : number_1.BN_ZERO).toString(10),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgEditOrder,
                value,
            }, opts);
        });
    }
    editOrders(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const msgs = params.map((param) => {
                var _a, _b;
                const value = tx_2.MsgEditOrder.fromPartial({
                    creator: wallet.bech32Address,
                    id: param.id,
                    price: param.price.shiftedBy(18).toString(10),
                    quantity: param.quantity.toString(10),
                    stopPrice: ((_b = (_a = param.stopPrice) === null || _a === void 0 ? void 0 : _a.shiftedBy(18)) !== null && _b !== void 0 ? _b : number_1.BN_ZERO).toString(10),
                });
                return {
                    typeUrl: util_1.CarbonTx.Types.MsgEditOrder,
                    value,
                };
            });
            return yield wallet.sendTxs(msgs, opts);
        });
    }
    cancelAll(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = tx_2.MsgCancelAll.fromPartial({
                creator: wallet.bech32Address,
                marketId: params.marketId,
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgCancelAll,
                value,
            }, opts);
        });
    }
}
exports.OrderModule = OrderModule;
(function (OrderModule) {
    let OrderType;
    (function (OrderType) {
        OrderType["Limit"] = "limit";
        OrderType["Market"] = "market";
        OrderType["StopLimit"] = "stop-limit";
        OrderType["StopMarket"] = "stop-market";
        OrderType["TakeProfitLimit"] = "take-profit-limit";
        OrderType["TakeProfitMarket"] = "take-profit-market";
        OrderType["Liquidation"] = "liquidation";
    })(OrderType = OrderModule.OrderType || (OrderModule.OrderType = {}));
    let OrderSide;
    (function (OrderSide) {
        OrderSide["Buy"] = "buy";
        OrderSide["Sell"] = "sell";
    })(OrderSide = OrderModule.OrderSide || (OrderModule.OrderSide = {}));
    let TriggerType;
    (function (TriggerType) {
        TriggerType["LastPrice"] = "last_price";
        TriggerType["MarkPrice"] = "mark_price";
        TriggerType["IndexPrice"] = "index_price";
    })(TriggerType = OrderModule.TriggerType || (OrderModule.TriggerType = {}));
    let TimeInForce;
    (function (TimeInForce) {
        TimeInForce["Gtc"] = "gtc";
        TimeInForce["Fok"] = "fok";
        TimeInForce["Ioc"] = "ioc";
    })(TimeInForce = OrderModule.TimeInForce || (OrderModule.TimeInForce = {}));
})(OrderModule = exports.OrderModule || (exports.OrderModule = {}));
